import { Button, Card, CardActions, CardContent, CardHeader, Divider, Modal } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import CloseIcon from '@material-ui/icons/Close';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css';
import { connect } from 'react-redux';
import Alert from 'src/components/Alert';
import axios from 'src/utils/axios';

const useStyles = makeStyles((theme) => ({
  rootKesifSms: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    outline: 'none',
    boxShadow: theme.shadows[20],
    width: 700,
    maxHeight: '100%',
    overflowY: 'auto',
    maxWidth: '100%'
  },
  actionsKesifSms: {
    justifyContent: 'flex-end'
  },
  submitButtonKesifSms: {
    marginTop: theme.spacing(2),
    width: '100%'
  }
}));
function KesifSmsGonder({ open, onClose, FisNo, tasks, className, headerTitle }) {
  const classes = useStyles();
  const [LoadingControl, setLoadingControl] = useState(false);
  const [uyariAciklama, setUyariAciklama] = useState('');
  const [uyari, setUyari] = useState(false);
  const [uyariTip, setUyariTip] = useState();
  let AramaData = [];
  if (tasks.tasks !== "") {
    AramaData = tasks.tasks.filter(d => parseInt(d.FisNo) === parseInt(FisNo));
  }

  if (!open) {
    return null;
  }

  const handleKesifSmsAtEvet = (event, tip) => {
    let KesifTip = 0;
    if (headerTitle === "Klima Keşif") {
      KesifTip = 1;
    }
    if (headerTitle === "Kombi Keşif") {
      KesifTip = 2;
    }
    if (headerTitle === "Termosifon Keşif") {
      KesifTip = 25;
    }
    setLoadingControl(true);
    let job = AramaData[0];
    axios.get(`SetArtemisKesifSms/${job.BasvuruNo}/${job.BIRIM_KODU}/${job.TEKNISYEN_KODU}/${tip || 0}/${KesifTip || 0}`)
      .then(response => {
        if (parseInt(response.data) === 1) {
          setLoadingControl(false);
          setUyariTip("success");
          setUyariAciklama('İşleminiz başarı ile gerçekleştirildi.');
          setUyari(true);
        } else {
          setLoadingControl(false);
          setUyariTip("error");
          setUyariAciklama(response.data);
          setUyari(true);
        }

      }).catch(error => {
        setLoadingControl(false);
        setUyariTip("error");
        setUyariAciklama(error.message);
        setUyari(true);
      })
  }


  const handleKesifSmsAt = (event, Telefon, tip, FisNo, Musteri) => {
    var Uyari = "Müşterimiz " + Musteri + " ın " + Telefon + " numaralı telefonuna " + headerTitle + " için sms gönderilecektir. Onaylıyor musunuz?";
    confirmAlert({
      message: Uyari,
      buttons: [
        {
          label: 'Evet',
          onClick: () => handleKesifSmsAtEvet(event, tip)
        },
        {
          label: 'Hayır',
          onClick: () => { return; }
        }
      ]
    });

  }
  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };

  const getTitle = (event) => {
    return event[0]?.FisNo + " " + event[0]?.Musteri + " " + event[0]?.BasvuruNedeni + " ilgili fiş için " + headerTitle + " sms'i gönderilecektir.";
  }


  return (
    <Modal
      onClose={onClose}
      open={open}
    >
      <Card
        className={clsx(classes.rootKesifSms, className)}
      >
        <form>
          <CardHeader title={getTitle(AramaData)} />
          <Divider />
          <CardContent>
            {
              LoadingControl ?
                <CircularProgress
                  status={'loading'}
                  style={{ marginLeft: '50%' }}
                />
                : <div></div>
            }
            <div>
              <div className={classes.wrapper}>
                {
                  AramaData[0]?.Telefon !== "" ?
                    <Button
                      variant="contained"
                      color="secondary"
                      className={classes.submitButtonKesifSms}
                      onClick={(event) => handleKesifSmsAt(event, AramaData[0]?.Telefon, 1, AramaData[0]?.FisNo, AramaData[0]?.Musteri)}
                      endIcon={<MailOutlineIcon>Call</MailOutlineIcon>}>
                      {/* maskPhoneNumber */}
                      {AramaData[0]?.Telefon}
                    </Button>
                    : <div></div>
                }
              </div>
              <div className={classes.wrapper}>
                {
                  AramaData[0]?.Telefon2 !== "" ?
                    <Button
                      variant="contained"
                      color="secondary"
                      className={classes.submitButtonKesifSms}
                      onClick={(event) => handleKesifSmsAt(event, AramaData[0]?.Telefon2, 2, AramaData[0]?.FisNo, AramaData[0]?.Musteri)}
                      endIcon={<MailOutlineIcon>Call</MailOutlineIcon>}>
                      {AramaData[0]?.Telefon2}
                    </Button>
                    : <div></div>
                }
              </div>
              <div className={classes.wrapper}>
                {
                  AramaData[0]?.Telefon3 !== "" ?
                    <Button
                      variant="contained"
                      color="secondary"
                      className={classes.submitButtonKesifSms}
                      onClick={(event) => handleKesifSmsAt(event, AramaData[0]?.Telefon3, 3, AramaData[0]?.FisNo, AramaData[0]?.Musteri)}
                      endIcon={<MailOutlineIcon>Call</MailOutlineIcon>}>
                      {AramaData[0]?.Telefon3}
                    </Button>
                    : <div></div>
                }
              </div>
              <div className={classes.wrapper}>
                {
                  AramaData[0]?.ArayanTelefon !== "" ?
                    <Button
                      variant="contained"
                      color="secondary"
                      className={classes.submitButtonKesifSms}
                      onClick={(event) => handleKesifSmsAt(event, AramaData[0]?.ArayanTelefon, 4, AramaData[0]?.FisNo, AramaData[0]?.Musteri)}
                      endIcon={<MailOutlineIcon>Call</MailOutlineIcon>}>
                      ArayanTelefon : {AramaData[0]?.ArayanTelefon}
                    </Button>
                    : <div></div>
                }
              </div>
              <div className={classes.wrapper}>
                {
                  AramaData[0]?.IrtibatTelefon !== "" ?
                    <Button
                      variant="contained"
                      color="secondary"
                      className={classes.submitButtonKesifSms}
                      onClick={(event) => handleKesifSmsAt(event, AramaData[0]?.IrtibatTelefon, 5, AramaData[0]?.FisNo, AramaData[0]?.Musteri)}
                      endIcon={<MailOutlineIcon>Call</MailOutlineIcon>}>
                      IrtibatTelefon : {AramaData[0]?.IrtibatTelefon}
                    </Button>
                    : <div></div>
                }
              </div>
              <div className={classes.wrapper}>
                {
                  AramaData[0]?.ALICI_GSM !== "" ?
                    <Button
                      variant="contained"
                      color="secondary"
                      className={classes.submitButtonKesifSms}
                      onClick={(event) => handleKesifSmsAt(event, AramaData[0]?.ALICI_GSM, 6, AramaData[0]?.FisNo, AramaData[0]?.Musteri)}
                      endIcon={<MailOutlineIcon>Call</MailOutlineIcon>}>
                      DoğrulamaTelefon : {AramaData[0]?.ALICI_GSM}
                    </Button>
                    : <div></div>
                }
              </div>
            </div>
            <div>
              {
                uyari ?
                  <Alert onClose={uyariKapat} open={uyari} message={uyariAciklama || ''} variant={uyariTip} />
                  : <div></div>
              }
            </div>
          </CardContent>
          <Divider />
          <CardActions className={classes.actionsKesifSms}>
            <Button
              variant="contained"
              color="secondary"
              endIcon={<CloseIcon>Onizleme</CloseIcon>}
              onClick={onClose}>
              Kapat
            </Button>
          </CardActions>
        </form>
      </Card>
    </Modal>
  );
}

KesifSmsGonder.propTypes = {
  className: PropTypes.string,
  FisNo: PropTypes.number,
  onClose: PropTypes.func,
  open: PropTypes.bool
};

KesifSmsGonder.defaultProps = {
  open: false,
  onClose: () => { }
};

export default connect(
  state => ({ tasks: state.tasks1 })
)(KesifSmsGonder);
